import FormLinkDescription from '@/forms/components/FormLinkDescription';
import fieldComponents from './helper';
import CatalogueLinkList from './components/CatalogueLinkList';
import CatalogueObjectList from './components/CatalogueObjectList';
import CatalogueObjectDescription from './components/CatalogueObjectDescription';

export default {
  ...fieldComponents,
  link: { editor: CatalogueLinkList, component: FormLinkDescription, hasLabel: true },
  object: { editor: CatalogueObjectList, component: CatalogueObjectDescription, hasLabel: true },
};
